import React, {
  useState, createContext, useEffect, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { useParams, useHistory, generatePath } from 'react-router-dom';
import { Paths } from 'router/routes';
import * as CertificadoApi from 'api/certificado';
import { getResponseError } from 'util/errorHelper';
import { isOnlyHexadecimal } from 'util/hexadecimal';

export const ValidacaoContext = createContext({
  data: null,
  loading: false,
  error: null,
  codigoConsulta: null,
  fetch: () => {},
  clear: () => {},
});

export const ValidacaoContextProvider = ({ children }) => {
  const { codigoConsulta: param } = useParams();
  const history = useHistory();
  const [codigoConsulta, setCodigo] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async (codigo) => {
    setError(null);
    setLoading(true);
    try {
      const { data: res } = await CertificadoApi.validarExterno(codigo);
      setData(res);
    } catch (err) {
      setError(getResponseError(err));
    } finally {
      setLoading(false);
    }
  }, [setData, setLoading, setError]);

  const clear = useCallback(() => {
    setData(null);
    setError(null);
    setLoading(false);
  }, [setData, setLoading, setError]);

  useEffect(() => {
    if (param) {
      if (isOnlyHexadecimal(param)) {
        fetch(param);
        setCodigo(param);
      } else {
        history.push(generatePath(Paths.VALIDACAO.split(':')[0]));
      }
    }
  }, [param, history, fetch, setCodigo]);

  return (
    <ValidacaoContext.Provider value={{
      data,
      loading,
      error,
      codigoConsulta,
      fetch,
      clear,
    }}
    >
      {children}
    </ValidacaoContext.Provider>
  );
};

ValidacaoContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
